import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react'

export type TicketBarTotals = {
  total: number
  requireProcessing: number
}

type Ctx = {
  totals: TicketBarTotals | null
  loading: boolean
  setTicketBarStats: (totals: TicketBarTotals | null, loading: boolean) => void
}

const TicketBarStatsContext = createContext<Ctx | null>(null)

export function TicketBarStatsProvider({ children }: { children: ReactNode }) {
  const [totals, setTotals] = useState<TicketBarTotals | null>(null)
  const [loading, setLoading] = useState(false)

  const setTicketBarStats = useCallback((next: TicketBarTotals | null, ld: boolean) => {
    setTotals(next)
    setLoading(ld)
  }, [])

  const value = useMemo(
    () => ({ totals, loading, setTicketBarStats }),
    [totals, loading, setTicketBarStats],
  )

  return <TicketBarStatsContext.Provider value={value}>{children}</TicketBarStatsContext.Provider>
}

export function useTicketBarStats(): Ctx {
  const c = useContext(TicketBarStatsContext)
  if (!c) throw new Error('useTicketBarStats must be used within TicketBarStatsProvider')
  return c
}
